module.exports = __webpack_public_path__ + "assets/img/store-reg-banner-02.14084c1a.png";